import { useEffect, useState } from '@bpmn-io/properties-panel/preact/hooks';
import type { FetchState } from '../../../types/properties-panel';
import type { SpSiteOrList } from '../../../types/sharepoint';
import { useMountRef } from './useMountRef';
import { useService } from './useService';

type FS = FetchState<SpSiteOrList[]>;

export const useFetchSpSiteLists = ({
    enabled = true,
    siteUrl,
}: {
    enabled?: boolean;
    siteUrl?: string;
}): FS => {
    const mountRef = useMountRef();
    const [state, setState] = useState<Record<string, FS>>({});
    const eventBus = useService('eventBus');

    // event listener
    useEffect(() => {
        const handler = (_event: any, siteUrl: string, newSiteListsState: FS) => {
            if (!mountRef.current) return;

            setState((prevState) => ({
                ...prevState,
                [siteUrl]: newSiteListsState,
            }));
        };

        eventBus.on('spSiteListsFetched', handler);
        return () => eventBus.off('spSiteListsFetched', handler);
    }, [siteUrl]);

    useEffect(() => {
        if (!enabled || !siteUrl) return;

        setState((prev) => {
            eventBus.fire('fetchSpSiteLists', siteUrl);
            const existing = prev[siteUrl];
            return {
                ...prev,
                [siteUrl]: {
                    loading: !existing?.data, // nur loading wenn noch keine Daten
                    data: existing?.data,
                    error: undefined,
                },
            };
        });
    }, [enabled, siteUrl]);

    return (siteUrl && state[siteUrl]) || {};
};
